import { Component, OnInit } from '@angular/core';
import { MenuComponent } from '../menu/menu.component';
import { ContenidoService } from '../contenido.service';

@Component({
  selector: 'app-ry-loyalty',
  templateUrl: './ry-loyalty.component.html',
  styleUrls: [
  '../../assets/css/bootstrap.min.css',
  '../../assets/scss/styles.scss', 
  '../../assets/scss/royal.scss', 
  '../../assets/scss/fonts.scss',
  './ry-loyalty.component.css',
  '../../assets/ema/main.scss',
  ]
})
export class RyLoyaltyComponent implements OnInit {
  public contenido = this.contenidoService.getContenido("ry-loyalty");
  constructor(private contenidoService: ContenidoService) {}

  ngOnInit() {
  }

}
